module.exports = __webpack_public_path__ + "static/media/team-small.b4e4faca.webp";